import { Box, Stack, Typography } from '@mui/material';
import MostPoularImage from '../../assets/images/most-popular.png';
import BestValueImage from '../../assets/images/best-value.png';

interface DashboardCardProps {
  backgroundColor: string;
  title: string;
  value: any;
  is_most_popular?: boolean;
  is_best_value?: boolean;
  is_credit: boolean;
  price?: number;
  count?: number;
  sub_title?: string;
}

export const DashboardCard = ({
  backgroundColor,
  title,
  value,
  is_most_popular,
  is_best_value,
  is_credit,
  price,
  count,
  sub_title,
}: DashboardCardProps) => {
  return (
    <Stack
      width="100%"
      borderRadius="16px"
      padding={3}
      boxShadow={`0px 4px 4px 0px #00000040`}
      sx={{ background: backgroundColor }}
      spacing={3}
      position="relative">
      <Box position="absolute" right="-4px" top="-4px">
        {is_most_popular ? (
          <img src={MostPoularImage} style={{ width: 140, height: 140 }} />
        ) : null}
        {is_best_value ? (
          <img src={BestValueImage} style={{ width: 140, height: 140 }} />
        ) : null}
      </Box>

      <Typography
        color="#040505"
        textAlign="center"
        variant="h4"
        fontWeight="300"
        fontFamily="korolev-condensed"
        mt={0}>
        {title}
      </Typography>
      {sub_title && (
        <Typography
          color="red"
          textAlign="center"
          variant="h6"
          fontWeight="700"
          fontFamily="korolev-condensed"
          sx={{
            marginTop: '0 !important',
          }}>
          {sub_title}
        </Typography>
      )}
      <Box
        display="flex"
        justifyContent="center"
        width="100%"
        sx={{
          marginTop: sub_title ? '0 !important' : 0,
        }}>
        <Box display="flex" alignItems="flex-end" position="relative">
          <Typography
            color="#040505"
            variant="h2"
            fontWeight="900"
            fontFamily="korolev-condensed"
            dangerouslySetInnerHTML={{ __html: value }}
            sx={{ width: 'max-content' }}
          />
          {is_credit && (
            <Typography
              sx={{
                fontSize: '1rem',
                fontWeight: 400,
                right: '-65px',
                top: '20%',
                position: 'absolute',
              }}>
              +VAT*
            </Typography>
          )}
        </Box>
      </Box>
      {is_credit && (
        <>
          <Typography
            marginTop="10px !important"
            fontWeight="bold"
            textAlign="center">
            {`£ ${(price ?? 0) / (count ?? 1)} per token`}
          </Typography>
        </>
      )}
    </Stack>
  );
};
